import axios from "../../utils/axiosConfig.js";
import { server } from "../../server/server.jsx";

// reset the user state
export const resetUserState = () => async (dispatch) => {
  dispatch({ type: "resetUserState" });
};

// Load User
export const loadUser = () => async (dispatch) => {
  try {
    dispatch({ type: "LoadUserRequest" });

    const { data } = await axios.get(`${server}/user/getuser`, {
      withCredentials: true,
    });

    dispatch({
      type: "LoadUserSuccess",
      payload: data.currentUser,
    });

  } catch (error) {
    dispatch({
      type: "LoadUserFail",
      payload: error.response?.data?.message || 'Something went wrong',
    });
  }
};

// Create User
export const createUser = (newUserData) => async (dispatch) => {
  try {
    dispatch({ type: "userCreateRequest" });

    const { data } = await axios.post(`${server}/user/create-user`, newUserData, { withCredentials: true });
    dispatch({
      type: "userCreateSuccess",
      payload: data.user,
    });
  } catch (error) {
    dispatch({
      type: "userCreateFail",
      payload: error.response?.data?.message || 'Something went wrong',
    });
  }
};

// Register User
export const registerUser = (newUserData) => async (dispatch) => {
  try {
    dispatch({ type: "registerUserRequest" });

    const { data } = await axios.post(`${server}/user/register`, newUserData);
    dispatch({
      type: "registerUserSuccess",
      payload: data.user,
    });
  } catch (error) {
    dispatch({
      type: "registerUserFail",
      payload: error.response?.data?.message || 'Something went wrong',
    });
  }
};

// Login User
export const loginUser = (userData) => async (dispatch) => {
  try {
    dispatch({ type: "userLoginRequest" }); // fixed action type

    const { data } = await axios.post(`${server}/user/login`, userData, {
      withCredentials: true,
      timeout: 30000, // 30 second timeout
    });
    dispatch({
      type: "userLoginSuccess",
      payload: data.currentUser,
    });
  } catch (error) {
    dispatch({
      type: "userLoginFail", // fixed action type
      payload: error.response?.data?.message || 'Something went wrong',
    });
  }
}

// Fetch All Users
export const getAllUsers = () => async (dispatch) => {
  try {
    dispatch({ type: 'getAllUsersRequest' });

    const { data } = await axios.get(`${server}/user/get-all-users`, {
      withCredentials: true,
    });

    dispatch({
      type: 'getAllUsersSuccess',
      payload: data.users,
    });
  } catch (error) {
    dispatch({
      type: 'getAllUsersFail',
      payload: error.response?.data?.message,
    });
  }
};

// Read all Users for a specific user ID
export const getAllUsersById = (userId) => async (dispatch) => {
  try {
    dispatch({ type: 'getAllUsersByIdRequest' });

    const { data } = await axios.get(`${server}/user/get-all-users/${userId}`, {
      withCredentials: true,
    });

    dispatch({
      type: 'getAllUsersByIdSuccess',
      payload: data.users,
    });
  } catch (error) {
    dispatch({
      type: 'getAllUsersByIdFail',
      payload: error.response?.data?.message,
    });
  }
};

// Super Admin InActivate user
export const inActivateUser = (userId, userStatus) => async (dispatch) => {
  try {
    dispatch({ type: "inActivateUserRequest" });

    const { data } = await axios.post(`${server}/user/inactivate-user/${userId}`, { userStatus }, { withCredentials: true });

    dispatch({
      type: "inActivateUserSuccess",
      payload: data.user,
    });

    // Optionally, fetch all users again to update the list
    dispatch(getAllUsers());
  } catch (error) {
    dispatch({
      type: "inActivateUserFail",
      payload: error.response?.data?.message || 'Something went wrong',
    });
  }
};

// Change Password
export const changePassword = (passwordData) => async (dispatch) => {
  try {
    dispatch({ type: "changePasswordRequest" });

    const { data } = await axios.put(`${server}/user/change-password`, passwordData, { withCredentials: true });
    dispatch({
      type: "changePasswordSuccess",
      payload: data.message,
    });
  } catch (error) {
    dispatch({
      type: "changePasswordFail",
      payload: error.response?.data?.message || 'Something went wrong',
    });
  }
};

// Get Single User
export const getSingleUser = (id) => async (dispatch) => {
  try {
    dispatch({ type: "getSingleUserRequest" });

    const { data } = await axios.get(`${server}/user/get-user/${id}`, {
      withCredentials: true,
    });

    dispatch({
      type: "getSingleUserSuccess",
      payload: data.user,
    });
  } catch (error) {
    dispatch({
      type: "getSingleUserFail",
      payload: error.response?.data?.message || 'Something went wrong',
    });
  }
};

// Get Referral User Details
export const getReferralUser = (referralId) => async (dispatch) => {
  try {
    dispatch({ type: "getReferralUserRequest" });

    const { data } = await axios.get(`${server}/user/get-referral-user/${referralId}`);

    dispatch({
      type: "getReferralUserSuccess",
      payload: data.user,
    });
  } catch (error) {
    dispatch({
      type: "getReferralUserFail",
      payload: error.response?.data?.message || 'Something went wrong',
    });
  }
};



// Edit User
export const editUser = (id, updatedData) => async (dispatch) => {
  try {
    dispatch({ type: "editUserRequest" });

    const { data } = await axios.put(`${server}/user/update-user/${id}`, updatedData, { withCredentials: true });

    dispatch({
      type: "editUserSuccess",
      payload: data.user,
    });

    // Optionally, fetch all users again to update the list
    dispatch(getAllUsers());
  } catch (error) {
    dispatch({
      type: "editUserFailed",
      payload: error.response?.data?.message || 'Something went wrong',
    });
  }
};

// Delete User
export const deleteUser = (id) => async (dispatch) => {
  try {
    dispatch({ type: "deleteUserRequest" });

    await axios.delete(`${server}/user/delete-user/${id}`, {
      withCredentials: true,
    });

    dispatch({
      type: "deleteUserSuccess",
      payload: id,
    });

    // Optionally, fetch all users again to update the list
    dispatch(getAllUsers());
  } catch (error) {
    dispatch({
      type: "deleteUserFail",
      payload: error.response?.data?.message || 'Something went wrong',
    });
  }
};

// Logout User
export const logoutUser = () => async (dispatch) => {
  try {
    await axios.get(`${server}/user/logout`, {
      withCredentials: true,
    });

    dispatch({ type: "LogoutSuccess" });

  } catch (error) {
    dispatch({
      type: "LogoutFail",
      payload: error.response?.data?.message || "Something went wrong",
    });
  }
};


// Verify Referral Code
export const verifyReferralCode = (referralCode) => async (dispatch) => {
  try {
    dispatch({ type: "verifyReferralCodeRequest" });

    const { data } = await axios.post(`${server}/user/verify-referral`, { referralCode }, { withCredentials: true });

    dispatch({
      type: "verifyReferralCodeSuccess",
      payload: data.message,
    });
  } catch (error) {
    dispatch({
      type: "verifyReferralCodeFail",
      payload: error.response?.data?.message || 'Something went wrong',
    });
  }
};

// Activate User
export const activateUser = (userId, amount) => async (dispatch) => {
  try {
    dispatch({ type: "activateUserRequest" });

    const { data } = await axios.post(`${server}/user/activate`, { userId, amount }, { withCredentials: true });

    dispatch({
      type: "activateUserSuccess",
      payload: data.user,
    });
  } catch (error) {
    dispatch({
      type: "activateUserFail",
      payload: error.response?.data?.message || 'Something went wrong',
    });
  }
};

// Forgot Password
export const forgotPassword = (email) => async (dispatch) => {
  try {
    dispatch({ type: "forgotPasswordRequest" });

    const { data } = await axios.post(`${server}/user/forgot-password`, { email });

    dispatch({
      type: "forgotPasswordSuccess",
      payload: data.message,
    });
  } catch (error) {
    dispatch({
      type: "forgotPasswordFail",
      payload: error.response?.data?.message || 'Something went wrong',
    });
  }
};

// Verify OTP
export const verifyOtp = (userData) => async (dispatch) => {
  try {
    dispatch({ type: "verifyOtpRequest" });

    const { data } = await axios.post(`${server}/user/verify-otp`, userData);

    dispatch({
      type: "verifyOtpSuccess",
      payload: data.message,
    });
  } catch (error) {
    dispatch({
      type: "verifyOtpFail",
      payload: error.response?.data?.message || 'Something went wrong',
    });
  }
};

// update user avatar
export const updateUserAvatar = (formData) => async (dispatch) => {
  try {
    dispatch({ type: "updateUserAvatarRequest" });

    const config = {
      headers: { "Content-Type": "multipart/form-data" },
      withCredentials: true,
    };

    const { data } = await axios.put(`${server}/user/update-avatar`, formData, config);

    dispatch({
      type: "updateUserAvatarSuccess",
      payload: data.user,
    });
  } catch (error) {
    dispatch({
      type: "updateUserAvatarFail",
      payload: error.response?.data?.message || 'Something went wrong',
    });
  }
};